import React from "react";

const GoRodCutting = () => {
  const handleRodCuttingClick = () => {
    const currentOrigin = window.location.origin;
    const rodCuttingUrl = `${currentOrigin}/rodCuttingAlgo`;
    window.open(
      rodCuttingUrl, 
      'RodCuttingWindow',
      'width=1400,height=900,scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no'
    );
  };

  return (
      <button className="btn btn-grid" onClick={handleRodCuttingClick}>
        RodCutting 바로가기
      </button>
  );
};

export default GoRodCutting;